import { HugeiconsIcon } from '@hugeicons/react';
import { Cancel01Icon } from '@hugeicons/core-free-icons';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

/** One tour step: count, title, a line or two, step dots and Back / Next. */
export default function TourCard({ step, body, index, total, isLast, onBack, onNext, onSkip }) {
  return (
    <div className="flex flex-col gap-3 p-4">
      <div className="flex items-center justify-between gap-3">
        <span className="text-xs font-medium text-muted-foreground tabular-nums">
          {index + 1} of {total}
        </span>
        <Button
          type="button"
          variant="ghost"
          size="icon-xs"
          className="-me-1 text-muted-foreground hover:text-foreground"
          aria-label="Close tour"
          onClick={onSkip}
        >
          <HugeiconsIcon icon={Cancel01Icon} strokeWidth={2} />
        </Button>
      </div>

      <div className="flex flex-col gap-1">
        <h2 className="text-[15px] font-semibold tracking-[-0.01em] text-balance">{step.title}</h2>
        <p className="text-[13.5px] leading-relaxed text-pretty text-muted-foreground">
          {body ?? step.body}
        </p>
      </div>

      <div className="flex items-center justify-between gap-3 pt-1">
        <div className="flex items-center gap-1" aria-hidden>
          {Array.from({ length: total }, (_, i) => (
            <span
              key={i}
              className={cn(
                'size-1.5 rounded-full transition-colors duration-200 ease-out-quad',
                i <= index ? 'bg-primary' : 'bg-foreground/15'
              )}
            />
          ))}
        </div>
        <div className="flex items-center gap-2">
          {index > 0 && (
            <Button type="button" variant="outline" size="sm" onClick={onBack}>
              Back
            </Button>
          )}
          <Button type="button" size="sm" onClick={onNext} data-tour-next>
            {isLast ? 'Done' : 'Next'}
          </Button>
        </div>
      </div>
    </div>
  );
}
